import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from '~/components/atomic';
import { useUpdateBlockedUserMutation } from '~/features/chatRoom';
import { useModal } from '~/hooks';
import { Member, ModalParams } from '~/types';
import { PAGE_ROUTE } from '~/constants';
import { useCommonChatStore, useUserStore } from '~/store';
import * as S from './GroupChatInfo.styled';

interface UserProps {
  chatroom_id: string;
  type: 'user' | 'ai';
  member: Member;
}

export default function Members({
  chatroom_id: groupchat_id,
  type,
  member: { id, name, is_blocked },
}: UserProps) {
  const email = useUserStore((state) => state.email);
  const { openModal } = useModal();
  const navigate = useNavigate();
  const updateBlockedMember = useCommonChatStore(
    (state) => state.updateBlockedMember,
  );
  const roomType = useCommonChatStore((state) => state.roomType);

  const [isUserBlocked, setIsUserBlocked] = useState(false);
  const { mutate: updateBlockedUserMutate } = useUpdateBlockedUserMutation();

  useEffect(() => {
    if (type === 'ai') return;
    if (is_blocked === undefined) return;
    setIsUserBlocked(is_blocked);
  }, [is_blocked]);

  const handleBlocked = async () => {
    const requestData = {
      email,
      groupchat_id,
      block_user_id: id,
      isBlocking: !isUserBlocked,
    };

    updateBlockedUserMutate(requestData, {
      onSuccess: ({ status }) => {
        updateBlockedMember({
          block_user_id: id,
          is_blocked: !isUserBlocked,
        });
        setIsUserBlocked(!isUserBlocked);
      },
    });
  };

  const toggleBlockUser = () => {
    if (!isUserBlocked) {
      const modalData: ModalParams = {
        title: 'Block',
        content: 'Blocked user will not be able to send you messages.',
        type: 'double_red',
        click: () => handleBlocked(),
        buttonName: 'Block',
      };

      openModal(modalData);
    } else {
      handleBlocked();
    }
  };

  return (
    <S.Members>
      <S.Character key={id}>{name}</S.Character>
      {type === 'ai' && (
        <button
          onClick={() =>
            navigate(`${PAGE_ROUTE.CHARACTER_DETAILS}/${id}`, {
              state: { fromChatRoom: true, type: roomType },
            })
          }
        >
          <Icon color='content_light_5' size={20} iconName='Tooltip' />
        </button>
      )}
      {type === 'user' && email !== id && (
        <button onClick={toggleBlockUser}>
          <Icon
            color='content_light_5'
            size={24}
            iconName={is_blocked ? 'UserDisable' : 'User'}
          />
        </button>
      )}
    </S.Members>
  );
}
